import cpfValidate from './cpfValidate';

export const emailRules = [
  (v) => !!v || 'E-mail é obrigatório.',
  (v) => /.+@.+\..+/.test(v) || 'Por favor, insira um e-mail válido.',
];

export const passwordRules = [
  (v) => !!v || 'Senha é obrigatória.',
  (v) => v.length >= 8 || 'A senha deve conter pelo menos 8 caracteres.',
];

export const fullNameRules = [(v) => !!v || 'Nome completo é obrigatório.'];

export const messageRules = [(v) => !!v || 'Mensagem é obrigatória.'];

export const topicRules = [(v) => !!v || 'Assunto é obrigatório.'];

export const stringRules = [(v) => !!v || 'O campo é obrigatório.'];

export const cpfRules = [
  (v) => cpfValidate(v) || 'Por favor, insira um cpf válido.',
];
